import { isMaximumGreaterThanMinimum } from '@seek/salary-data';

import type { GetMinMaxAndAllowablesResult } from 'src/app/v1/views/components/Pay/util/getMinMaxAndAllowables';
import type { ValidationTranslations } from 'src/app/v1/views/components/Pay/util/getValidationTranslations';

import type { SalaryError } from './types';

export const getErrorForMaxValidationType = (
  {
    tValMaxRequired,
    tValMaxGreaterThanMinAllowable,
    tValMaxLesserThanMaxAllowable,
    tValMaxGreaterThanMin,
  }: ValidationTranslations,
  {
    maximumText,
    maximum,
    minimum,
    minAllowableSalary,
    maxAllowableSalary,
  }: Pick<
    GetMinMaxAndAllowablesResult,
    | 'minimum'
    | 'maximum'
    | 'maximumText'
    | 'minAllowableSalary'
    | 'maxAllowableSalary'
  >,
): SalaryError => {
  if (!maximumText || maximumText.trim().length === 0 || isNaN(maximum)) {
    return { max: tValMaxRequired };
  }
  if (maximum < minAllowableSalary) {
    return { max: tValMaxGreaterThanMinAllowable };
  }
  if (maximum > maxAllowableSalary) {
    return {
      max: tValMaxLesserThanMaxAllowable,
    };
  }
  if (!isMaximumGreaterThanMinimum({ minimum, maximum })) {
    return { max: tValMaxGreaterThanMin };
  }
  return { max: null };
};
